import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import common, {
  externalCodeSaga,
  memberFilterSaga,
  getCategorySaga,
} from './common';
import auth, { authSaga } from './auth';
import menu, { menuSaga } from './menu';
import locale, {
  localeSaga,
  changeLocaleSaga,
  localeSetStorageSaga,
} from './locale';
import loading from './loading';
import portal from './portal';
import snackbar from './snackbar';
import filter from './filter';

const rootReducer = combineReducers({
  common,
  auth,
  menu,
  locale,
  loading,
  portal,
  snackbar,
  filter,
});

export function* rootSaga() {
  yield all([
    externalCodeSaga(),
    memberFilterSaga(),
    getCategorySaga(),
    authSaga(),
    menuSaga(),
    localeSaga(),
    changeLocaleSaga(),
    localeSetStorageSaga(),
  ]);
}

export default rootReducer;
